import React from 'react';
import { Row, Col, Switch } from 'antd';
import DashboardLayout from 'layouts/Dashboard';
import Container from 'components/Container';
import useMfgLookup from './hooks/useMfgLookup';
import ListFilterForm from './ListFilterForm';
import MasterTable from 'components/MasterTable';
import { useDispatch, useSelector } from 'react-redux';
import deleteMfgLookup from 'api/deleteMfgLookup'
import { setCurrentPage, setPageSize, reset } from 'redux/modules/mfgLookup/slice';
import { getApp, getMfgLookup } from 'selectors';
import useSave from './hooks/useSave';
const MfgLookup = () => {
  const loading = useMfgLookup();
  const dispatch = useDispatch();
  const { manufactures, distributors } = useSelector(getApp);
  const { mfgLookupList, totalCount } = useSelector(getMfgLookup);
  const handlePagination = (page: number, pageSize?: number) => {
    dispatch(setCurrentPage(page));
    dispatch(setPageSize(pageSize));
  };

  const columns = [
    {
      title: 'Manufacturer ',
      dataIndex: 'mfg',
      key: 'mfg',
      editable: true
    },
    {
      title: 'Distributor',
      dataIndex: 'distributor',
      key: 'distributor',
      editable: true
    },
    {
      title: 'State Code',
      dataIndex: 'location',
      key: 'location',
      editable: true
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (val: any) => <Switch checked={val} />,
     
    }
  ];

  const formFields = [
    {
      label: 'Choose Manufacturer',
      name: 'mfg',
      dataSource: manufactures,
      valueKey: 'mfgName'
    },
    {
      label: 'Choose Distributor',
      name: 'distributor',
      dataSource: distributors,
      valueKey: 'distributionName'
    },
    {
      label: 'State',
      name: 'state'
    },
    {
      label: 'State Code',
      name: 'location'
    },
    {
      name: 'status',
      label: 'Status',
      status: true
    }
  ];

  return (
    <DashboardLayout title="Mfg Lookup" path={['Home', 'Mfg Lookup']}>
      <Row gutter={10} style={{ margin: '0px' }} align="middle">
        <Col md={24} xs={24}>
          <Container title="Mfg Lookup">
            <ListFilterForm />
            <MasterTable
              onSave={useSave}
              onDelete={deleteMfgLookup}
              reset={reset}
              listData={mfgLookupList}
              columnData={columns}
              formFields={formFields}
              isLoading={loading}
              pagination={{
                onChange: handlePagination,
                total: totalCount
              }}
            />
          </Container>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default MfgLookup;
